import { ApiService } from "pwapi";

import { AsyncSagaAction, createAsyncSaga } from "../../utils/asyncActions";
import {
  ADMIN_CREATE_SPECIMEN_FAILURE,
  ADMIN_CREATE_SPECIMEN_REQUEST,
  ADMIN_CREATE_SPECIMEN_SUCCESS,
  ADMIN_DELETE_SPECIMEN_FAILURE,
  ADMIN_DELETE_SPECIMEN_REQUEST,
  ADMIN_DELETE_SPECIMEN_SUCCESS,
  ADMIN_UPDATE_SPECIMEN_REQUEST,
} from "../adminConstants";

type createSpecimenArgs = Parameters<typeof ApiService.createAdminSpecimen>[0];

export const createSpecimen = createAsyncSaga(
  ADMIN_CREATE_SPECIMEN_REQUEST,
  ADMIN_CREATE_SPECIMEN_SUCCESS,
  ADMIN_CREATE_SPECIMEN_FAILURE,
  () => "admin/specimens/create",
  ApiService.createAdminSpecimen
) as AsyncSagaAction<createSpecimenArgs>;

export const updateSpecimen = (payload = {}) => {
  return {
    type: ADMIN_UPDATE_SPECIMEN_REQUEST,
    payload,
  };
};

export const deleteSpecimen = createAsyncSaga(
  ADMIN_DELETE_SPECIMEN_REQUEST,
  ADMIN_DELETE_SPECIMEN_SUCCESS,
  ADMIN_DELETE_SPECIMEN_FAILURE,
  ({ id }) => `admin/specimens/${id}/delete`,
  ApiService.destroyAdminSpecimen
);
